import React from "react";
import { compose, withAppContext, withState, withActions } from "containers/HOC";
import { Link } from "react-router-dom";
import * as icons from "common/icons";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import FarmList from "./FarmList";
import { getMyFarms } from "./_actions";
import ZendeskLink from "components/Help/ZendeskLink";
import CreateFarmLink from "containers/Farm/CreateFarmLink";

const MyFarms = ({ online, getMyFarms, myFarmsLoading, myFarms, myFarmsForceReload, refData, authContext }) => {
    React.useEffect(() => {
        getMyFarms();
    }, [online, getMyFarms, myFarmsForceReload]);

    const loading = online && myFarmsLoading;

    const hasMyFarms = myFarms && myFarms.length > 0;
    const { accountType = "Standard" } = authContext;
    const isStudent = refData.deploymentType === "Education" && accountType === "Student";
    const isEducationProvider = refData.deploymentType === "Education" && accountType === "EducationProvider";

    return (
        <>
            {hasMyFarms && (isStudent || isEducationProvider) && (
                <Panel title={isStudent ? "Templates" : "Shared with student groups"} iconClassName="IconLink--blocks" loading={loading}>
                    <PanelBody loading={!myFarms && loading}>
                        <FarmList farms={myFarms} reload={getMyFarms} templates={true} />
                    </PanelBody>
                </Panel>
            )}
            <Panel title="My farms" iconClassName="IconLink--blocks" loading={loading}>
                <PanelBody loading={!myFarms && loading}>
                    {hasMyFarms && <FarmList farms={myFarms} reload={getMyFarms} />}
                    {!hasMyFarms && (
                        <div className="Tile-body-message">
                            <div className="Alert Alert--info" style={{ textAlign: "left", marginTop: "-60px" }}>
                                <i className="icon icon-info" id="register-info" />
                                <span>
                                    Please read the{" "}
                                    <b>
                                        {" "}
                                        <ZendeskLink title="farm account guide" url="https://support.overseer.org.nz/hc/en-us/articles/900000887303" rel="noopener noreferrer" target="_blank" />
                                    </b>{" "}
                                    to help you get started with creating farms.
                                    <br /> For any other help, please search the{" "}
                                    <b>
                                        <ZendeskLink title="OverseerFM knowledge base." url="https://support.overseer.org.nz/" rel="noopener noreferrer" target="_blank" />
                                    </b>
                                </span>
                            </div>
                            <img src={icons.add} alt="Plus" />
                            <p className="lead">You do not have any farms</p>
                            <CreateFarmLink id="farm-list-create" className="Button Button--lg u-mt-lg" />
                            {online && (
                                <Link to="/app/search/farms" id="farm-search-link" className="IconLink--search Button Button--lg u-mt-md">
                                    Find existing farms
                                </Link>
                            )}
                        </div>
                    )}
                </PanelBody>
            </Panel>
        </>
    );
};

export default compose(
    withAppContext,
    withState((state) => ({
        myFarms: state.dashboard.myFarms,
        myFarmsLoading: state.dashboard.myFarmsLoading,
        myFarmsForceReload: state.dashboard.myFarmsForceReload,
    })),
    withActions({
        getMyFarms,
    })
)(MyFarms);
